import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
// material-ui icons
import Check from '@material-ui/icons/Check';
// graphql
import gql from 'graphql-tag';
// our components
import StatsPeriod from 'components/common/StatsPeriod/StatsPeriod';
import Stats from 'components/common/Stats/Stats';

export const REVIEWED_ADS_QUERY = gql`
  query reviewedAds($minDate: Date!, $maxDate: Date!) {
    reviewedAdsStats(minDate: $minDate, maxDate: $maxDate) {
      total
    }
  }
`;

const AdReviewedStats = ({ t }) => (
  <StatsPeriod query={REVIEWED_ADS_QUERY}>
    {({ data, updateData }) => (
      <Stats
        title={t('dashboard.reviewed_ads')}
        color="success"
        icon={<Check />}
        data={data && data.reviewedAdsStats ? data.reviewedAdsStats.total : 0}
        statsUpdate={date => updateData(date)}
      />
    )}
  </StatsPeriod>
);

AdReviewedStats.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(AdReviewedStats);
